import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import { useLoading } from '../../contexts/LoadingContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
  isHR?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  isHR,
}) => {
  const { ensureAuth, authenticated, keycloak, login } = useAuth();
  const { showLoading, hideLoading } = useLoading();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    showLoading('Loading...');

    ensureAuth()
      .then((isAuth) => {
        setAuthChecked(true);
        if (!isAuth) {
          login();
        }
      })
      .catch((error) => {
        console.error('Auth check failed:', error);
        setAuthChecked(true);
      })
      .finally(() => {
        hideLoading();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - run once on mount

  // Still checking auth - GlobalLoading will show
  if (!authChecked) {
    return null;
  }

  // Not authenticated - login() was called, waiting for redirect
  if (!authenticated) {
    return null;
  }

  // Role guard
  if (isHR === true && !keycloak.hasResourceRole('hr')) {
    return <Navigate to="/unauthorized" replace />;
  }
  if (isHR === false && keycloak.hasResourceRole('hr')) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
